export const state = () => ({
    fullscreen_overlay_count: 0,
});
